/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-10 22:11:09
 */
import Vue from 'vue'
import Vuex from 'vuex'
import { setCookie, getLocal, getCookie } from '@/utils/cookie'
import { getConfig, wxLogin } from '@/api/api'

Vue.use(Vuex)

const topToastText = '承诺30天包成功，不成功可申请全额退款'

const state = {
  userInfo: {},
  tradeId: '',
  cityName: '',
  publishId: '',
  isType2: false,
  config: {
    topToastText: '',
    homeNumData: {
      todayTraffic: '',
      shopSuccessfullyFound: '',
      tradingVolumeToday: ''
    },
    servicePhoneList: []
  },
  personList: [],
  turnover: 0,
  token: getCookie('asses_token')
}

const mutations = {
  SET_CITY: (state, cityName) => {
    state.cityName = cityName
  },
  SET_TRADEID: (state, tradeId) => {
    state.tradeId = tradeId
  },
  SET_PUBLISHID: (state, publishId) => {
    state.publishId = publishId
  },
  SET_CONFIG: (state, config) => {
    state.config = config
  },
  SET_TYPE2: (state, isType2) => {
    state.isType2 = isType2
  },
  SET_PERSONLIST: (state, personList) => {
    state.personList = personList
  },
  SET_TUROVER: (state, turnover) => {
    state.turnover = turnover
  },
  SET_TOKEN: (state, token) => {
    // state.token= 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYmNiZmQ4MzYzMGI0YTIxOWE1MDhlMmRlMDc1MGI5MSJ9.d2wInfCBJz_a4N1aGqxqW22ZYXcrBvUtOy4MLlXe0W0'
     state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  getLogin({ commit }, code) {
    return new Promise(resolve => {
      wxLogin({ code }).then(res => {
        const { token } = res.data
        commit('SET_TOKEN', token)
        setCookie('asses_token', token)
        resolve(token)
      })
    })
  },
  setUserInfo({ commit }, userInfo) {
    return new Promise(resolve => {
      commit('SET_USERINFO', userInfo)
      getLocal('userInfo', userInfo)
      resolve()
    })
  },
  setTurnover({ commit }, turnover) {
    return new Promise(resolve => {
      commit('SET_TUROVER', turnover)
      setCookie('turnover', turnover)
      resolve()
    })
  },
  setToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      setCookie('asses_token', token)
      resolve()
    })
  },
  setPersonList({ commit }, personList) {
    return new Promise(resolve => {
      commit('SET_PERSONLIST', personList)
      setCookie('personList', JSON.stringify(personList))
      resolve()
    })
  },
  setType2({ commit }, isType2) {
    return new Promise(resolve => {
      commit('SET_TYPE2', isType2)
      setCookie('isType2', isType2)
      resolve()
    })
  },
  setTradeId({ commit }, tradeId) {
    return new Promise(resolve => {
      commit('SET_TRADEID', tradeId)
      setCookie('tradeId', tradeId)
      resolve()
    })
  },
  setCity({ commit }, cityName) {
    return new Promise(resolve => {
      commit('SET_CITY', cityName)
      setCookie('cityName', cityName)
      resolve()
    })
  },
  setPublishId({ commit }, publishId) {
    return new Promise(resolve => {
      commit('SET_PUBLISHID', publishId)
      setCookie('publishId', publishId)
      resolve()
    })
  },
  // 只请求一次config
  setConfig({ rootState, commit }) {
    return new Promise(resolve => {
      if (!rootState.config.topToastText) {
        getConfig().then(res => {
          commit('SET_CONFIG', { ...res.data, topToastText })
          setCookie('config', JSON.stringify(res.data))
          resolve(res.data)
        })
      } else {
        resolve(rootState.config)
      }
    })
  },
  // 刷新存config
  setOnFreshConfig({ commit }, config) {
    return new Promise(resolve => {
      if (config && config !== 'undefined') {
        commit('SET_CONFIG', JSON.parse(config))
      }
      resolve()
    })
  }
}

const getters = {
  config: state => state.config,
  isType2: state => state.isType2,
  cityName: state => state.cityName,
  publishId: state => state.publishId,
  tradeId: state => state.tradeId,
  personList: state => state.personList,
  turnover: state => state.turnover,
  token: state => state.token,
    userInfo: state => state.userInfo,
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
